import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import { AspectRatioLabel, ASPECT_MAP } from '@anm/data/aspects';
import { PageName } from '@anm/data/video-templates/pages';
import compactProps from '@anm/helpers/compactProps';
import compose from 'lodash/fp/compose';
import omitBy from 'lodash/fp/omitBy';
import { RouteParams } from 'next-routes';

import routes from '../../../routes';

const { Router } = routes;

export const getTemplateParams = (
  isMainPage: boolean,
  params: RouteParams,
  omitKeys = [isMainPage ? 'pageName' : '', 'page']
) =>
  compose(
    compactProps,
    omitBy((_: string, key: string) => omitKeys.includes(key))
  )(params) as RouteParams;

export const getAspectParam = (aspects: string | null) =>
  Object.keys(ASPECT_MAP).reduce(
    (acc, aspectLabel) => (ASPECT_MAP[aspectLabel as AspectRatioLabel] === aspects ? aspectLabel : acc),
    ''
  );

export const getRouterParams = (pageName: PageName, aspects: string | null) => {
  const aspectParam = getAspectParam(aspects);

  const isMainPage = pageName === 'main';

  const params = getTemplateParams(isMainPage, {
    ...Router.router?.query,
    aspects: aspectParam || null,
    ...(!isMainPage && { pageName })
  } as RouteParams);

  const route = isMainPage ? 'video-templates' : VIDEO_TEMPLATE_ROUTE;

  return [route, params] as const;
};
